import "./App.css";
import Logo from "./logo/Logo";
import Navbar from "./navbar/Navbar";

function App() {
  return (
    <>
      <div className="container">
        <Logo />
        <Navbar />
      </div>
    </>
  );
}

export default App;
